export var xDai = {
  chainId: 100,
  chainName: 'xDai',
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: '0xb5b692a88bdfc81ca69dcb1d924f59f0413a602a',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://blockscout.com/poa/xdai/address/".concat(address, "/transactions");
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://blockscout.com/poa/xdai/tx/".concat(transactionHash, "/internal-transactions");
  }
}; // xdai alias

export var Gnosis = Object.assign(Object.assign({}, xDai), {
  chainName: 'Gnosis'
});
export default {
  xDai: xDai,
  Gnosis: Gnosis
};